import Picker from "../picker";
import DatePanel from "../panel/date";
import DateRangePanel from "../panel/date-range";
import MonthRangePanel from "../panel/month-range";
import QuarterRangePanel from "../panel/quarter-range";

const getPanel = function (type) {
  if (type === "daterange" || type === "datetimerange") {
    return DateRangePanel;
  } else if (type === "monthrange") {
    return MonthRangePanel;
  } else if (type === "quarterrange") {
    return QuarterRangePanel;
  } else if (type === "quarter" || type === "date") {
    console.log(type);
    return DatePanel;
  }
  return DatePanel;
};

export default {
  mixins: [Picker],

  name: "SgDatePicker",

  props: {
    type: {
      type: String,
      default: "date",
    },
    timeArrowControl: Boolean,

    suffix: {
      type: Function,
    },
    footerHtml: {
      type: String,
    },
  },

  watch: {
    type(type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = getPanel(type);
        this.mountPicker();
      } else {
        this.panel = getPanel(type);
      }
    },
  },

  created() {
    this.panel = getPanel(this.type);
  },
};
